const ferries = {
  ferry: "Feri", // translated 
  ferries: "Feri", // translated 
  selectOriginPort: "Pilih Port asal", // translated 
  selectDestPort: "Pilih Port tujuan", // translated 
  continue: "Melanjutkan", // translated 
  viewTimetables: "Lihat Jadwal", // translated 
  operator: "Operator", // translated 
  cabin: "Kabin", // translated 
  cabins: "Kabin", // translated 
  place: "Tempat", // translated 
  places: "Tempat", // translated 
  seat: "Kursi", // translated 
  seats: "Tempat duduk", // translated 
  seating: "Tempat duduk", // translated 
  deckSpace: "Ruang Dek", // translated 
  compulsory: "wajib", // translated 
  departure: "Keberangkatan", // translated 
  total: "Total", // translated 
  back: "Kembali", // translated 
  next: "Berikutnya", // translated 
  duration: "Durasi", // translated 
  return: "Kembali", // translated 
  prebook: "Pesan terlebih dahulu", // translated 
  travelInfo: "Info Perjalanan", // translated 
  book: "Buku", // translated 
  adults: "Dewasa", // translated 
  child: "Anak", // translated 
  seniors: "Senior", // translated 
  senior: "Senior", // translated 
  to: "ke", // translated 
  passenger: "Penumpang", // translated 
  details: "Detail", // translated 
  currencyForTickets: "Mata uang untuk tiket ini adalah", // translated 
  seatsError: "Jumlah penumpang tidak sebanding dengan kapasitas.", // translated 
  title: "Judul", // translated 
  firstName: "Nama depan", // translated 
  lastName: "Nama keluarga", // translated 
  email: "Surel", // translated 
  phone: "Telepon", // translated 
  dateOfBirth: "Tanggal lahir", // translated 
  placeOfBirth: "Tempat Lahir", // translated 
  groupLeader: "Pemimpin grup", // translated 
  isRequired: "Dibutuhkan", // translated 
  charactersOnly: "Hanya Karakter", // translated 
  latinCharactersAndSpacesOnly: "Hanya Karakter dan Spasi Latin", // translated 
  validEmail: "Bukan email yang valid", // translated 
  atLeastOneAdult: "Setidaknya diperlukan 1 orang dewasa.", // translated 
  atLeastOneSenior: "Setidaknya diperlukan 1 senior.", // translated 
  toastAlert: "Harap perbaiki semua kesalahan pada formulir di bawah ini.", // translated 
  backToFerriesList: "Kembali ke Daftar Feri", // translated 
  bestPrice: "Harga terbaik", // translated 
  fastest: "Tercepat", // translated 
  beforeDeparture: "Sebelum keberangkatan", // translated 
  perPerson: "per orang", // translated 
  notAvailableForOnlineBooking: "Tidak tersedia untuk pemesanan online", // translated 
  hurryLimitedAvailability: "Ayo cepat! Persediaan terbatas", // translated 
  berth: "Tempat tidur", // translated 
  berths: "tempat berlabuh", // translated 
  sumOfSelectionNotEqualToPersons:
    "Jumlah pilihan Anda tidak sama dengan jumlah penumpang", // translated 
  attemptToBook: "Anda telah mencoba memesan total", // translated 
  seatsWhenYouHave: "kursi ketika Anda punya", // translated 
  passengersTravelling: "penumpang bepergian", // translated 
  withReturn: "dengan tiket pulang pergi", // translated 
  pleaseCorrectYourSelection: "Harap perbaiki pilihan Anda", // translated 
  pleaseSelectUpTo: "Silakan pilih hingga", // translated 
  accommodationTypes: "jenis akomodasi", // translated 
  selectionPrices: "Harga Seleksi", // translated 
  yourCurrentTicket: "Jenis tiket Anda saat ini adalah", // translated 
  upgradeTo: "Tingkatkan ke", // translated 
  wouldYouLikeToUpgrade: "Apakah Anda ingin meningkatkan jenis tiket Anda?", // translated 
  backToTicketTypes: "Kembali ke Jenis Tiket", // translated 
  originPort: "Pelabuhan Asal", // translated 
  destinationPort: "Pelabuhan Tujuan", // translated 
  outboundDate: "Tanggal Keluar", // translated 
  inboundDate: "Tanggal Masuk", // translated 
  passengers: "Penumpang", // translated 
  hasReturn: "Telah Kembali", // translated 
  passportNumber: "Nomor paspor", // translated 
  passportExpiryDate: "Tanggal Kedaluwarsa Paspor", // translated 
  passportPlaceOfIssue: "Tempat Penerbitan Paspor", // translated 
  passportStartDate: "Tanggal Mulai Paspor", // translated 
  cityCode: "Kode kota", // translated 
};



export default ferries;
